import _objectSpread from "/azp/_work/6/s/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.repeat.js";
import "core-js/modules/web.dom-collections.for-each.js";
/* eslint-disable */
import CommonTable from '@/components/CommonTable';
import variables from '@/styles/variables.module.scss';
import request from '@/request';
import download from '@/request/download';
import ResultDialog from './ResultDialog';
import { declarationTypes } from '@/assets/mock-data';
export default {
  components: {
    CommonTable: CommonTable,
    ResultDialog: ResultDialog
  },
  props: {
    showDrawer: {
      type: Boolean
    }
  },
  data: function data() {
    return {
      selectFile: null,
      tableData: [],
      files: [],
      columns: [{
        label: '列表行',
        prop: 'row',
        width: '60'
      }, {
        label: '运单号',
        prop: 'trackingNumber',
        width: '150'
      }, {
        label: '异常原因',
        prop: 'desc',
        width: '100'
      }],
      options: {
        index: false,
        size: 'large',
        stripe: false,
        align: 'left',
        multipleRowSelect: false,
        commonStyle: {},
        headStyle: {
          background: variables.rowBg
        },
        page_index: 0,
        rowStyle: this.tableRowStule
      },
      filterOptions: [{
        value: '0',
        label: '所有'
      }, {
        value: '1',
        label: '已读'
      }, {
        value: '2',
        label: '未读'
      }],
      filterCheckedValue: '',
      total: 0,
      currentPage: 1,
      detailTotal: 0,
      detailCurrentPage: 1,
      detailId: '',
      input: '',
      dateRange: [],
      fileType: '',
      fileTypes: [{
        label: '固定模板',
        value: '1'
      }, {
        label: '自定义模板',
        value: '2'
      }],
      declarationTypes: declarationTypes,
      declarationFormType: ''
    };
  },
  mounted: function mounted() {
    this.show();
  },
  methods: {
    show: function show(file) {
      this.files = [];
      this.selectFile = file;
      if (!this.selectFile) {
        // 获取历史列表
        this.httpGetHistory();
      }
    },
    showDetail: function showDetail(file) {
      if (file.abnormal === 0 && file.repeat === 0 || !file.logDetail) return;
      this.detailId = file.id;
      this.getDetail();
      // this.$refs.resultDialogRef.show(this.detailId)
      // 修改日志状态
      request({
        url: '/api/v1/upload/confirm/' + file.id,
        method: 'PUT',
        hiddenLoading: true
      }).then(function (res) {});
    },
    tableRowStule: function tableRowStule(_ref) {
      var row = _ref.row,
        rowIndex = _ref.rowIndex;
      var background = rowIndex % 2 === 0 ? variables.menuBg : variables.rowBg;
      return {
        background: background
      };
    },
    httpGetHistory: function httpGetHistory() {
      var _this = this;
      request({
        url: "/api/v1/upload/query/log/history",
        method: 'get',
        params: {
          pageNo: this.currentPage,
          pageSize: 10,
          confirm: this.filterCheckedValue === '1' ? true : this.filterCheckedValue === '2' ? false : '',
          beginUploadDate: this.dateRange && this.dateRange.length > 0 ? this.dateRange[0] : '',
          endUploadDate: this.dateRange && this.dateRange.length > 0 ? this.dateRange[1] : '',
          isFix: !this.fileType ? undefined : this.fileType === '1',
          declarationFormType: this.declarationFormType,
          fileName: this.input
        }
      }).then(function (res) {
        if (res) {
          _this.files = [];
          res.records.forEach(function (item) {
            _this.files.push(_objectSpread(_objectSpread({}, item), {}, {
              logDetail: item.logDetail && item.logDetail.length > 0 ? JSON.parse(item.logDetail) : null
            }));
          });
          _this.total = res.total;
        }
      });
    },
    reLoad: function reLoad() {
      //this.$emit('changeShowDrawer',false)
      //this.$root.isuploadDialog = true
      download({
        url: '/api/v1/upload/download/desc',
        method: 'GET',
        params: {
          id: this.detailId
        }
      }, {
        'type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'fileType': ''
      }).then(function (res) {});
    },
    goBack: function goBack() {
      this.selectFile = null;
      this.detailTotal = 0;
      this.detailCurrentPage = 1;
      this.httpGetHistory();
    },
    filterChange: function filterChange() {
      this.httpGetHistory();
    },
    fileTypeChange: function fileTypeChange(val) {
      this.httpGetHistory();
    },
    declarationFormTypeChange: function declarationFormTypeChange() {
      this.httpGetHistory();
    },
    currentChange: function currentChange(currentPage) {
      this.currentPage = currentPage;
      this.httpGetHistory();
    },
    detailCurrentChange: function detailCurrentChange(currentPage) {
      this.detailCurrentPage = currentPage;
      this.getDetail();
    },
    getDetail: function getDetail() {
      var _this2 = this;
      request({
        url: '/api/v1/upload/query/log/history/detail/' + this.detailId,
        method: 'GET',
        params: {
          pageNo: this.detailCurrentPage,
          pageSize: 10
        }
      }).then(function (res) {
        _this2.selectFile = res;
        _this2.getDetailTableData();
        _this2.detailTotal = res.total;
      });
    },
    onInputEnter: function onInputEnter() {
      this.httpGetHistory();
    },
    onInputClear: function onInputClear() {
      this.httpGetHistory();
    },
    onDateChange: function onDateChange() {
      this.httpGetHistory();
    },
    getFileTypeStr: function getFileTypeStr(type) {
      if (!type || type.length === 0) return '';
      if (type === 'OB') return '个人物品申报(B类)出口报关';
      if (type === 'OC') return '低值货物快件(C类)出口报关';
      if (type === 'OD') return '正式申报类货物(D类)出口报关';
      if (type === 'IB') return '个人物品申报(B类)进口报关';
      if (type === 'IC') return '低值货物快件(C类)进口报关';
      if (type === 'ID') return '正式申报类货物(D类)进口报关';
      return '';
    },
    getDetailTableData: function getDetailTableData() {
      if (!this.selectFile) return [];
      if (!this.selectFile.isFixed && !this.selectFile.isRowData) {
        this.columns = [{
          label: '序号',
          prop: 'row',
          width: '60'
        }, {
          label: '文件名',
          prop: 'fileName',
          width: '150'
        }, {
          label: '异常原因',
          prop: 'desc',
          width: '100'
        }];
        // 草单
        this.tableData = this.selectFile.logFileDetailList;
      } else {
        this.columns = [{
          label: '列表行',
          prop: 'row',
          width: '60'
        }, {
          label: '运单号',
          prop: 'trackingNumber',
          width: '150'
        }, {
          label: '异常原因',
          prop: 'desc',
          width: '100'
        }];
        this.tableData = this.selectFile.logDetailList;
      }
    },
    getUnitString: function getUnitString(item) {
      if (!item.isFixed && !item.isRowData) {
        return '个文件';
      }
      return '条';
    }
  }
};